var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Find")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { "aria-label": "Close", type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _setup.searchStr,
              expression: "searchStr",
            },
            { name: "select", rawName: "v-select" },
          ],
          staticClass: "form-control input-lg",
          attrs: { autocomplete: "off", placeholder: "Search", type: "text" },
          domProps: { value: _setup.searchStr },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _setup.searchStr = $event.target.value
              },
              _setup.search,
            ],
          },
        }),
        _vm._v(" "),
        _setup.items
          ? _c(
              "div",
              {
                staticClass:
                  "my-3 list-group list-group-numbered list-group-flush",
              },
              _vm._l(_setup.items, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "list-group-item d-flex py-1 px-3",
                    class: { active: index === _setup.findModalItemIndex },
                    on: {
                      click: function ($event) {
                        return _setup.selectItem(index)
                      },
                      dblclick: function ($event) {
                        return _setup.openItem(index)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "flex-fill ps-1 text-nowrap overflow-hidden",
                      domProps: { innerHTML: _vm._s(item.line) },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex-shrink-1 text-nowrap text-end ps-3",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item.title) +
                            " " +
                            _vm._s(item.lineNumber + 1) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.value
          ? _c("div", [
              _c("textarea", {
                ref: "codeMirrorTextArea",
                domProps: { innerHTML: _vm._s(_setup.value) },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }